export default [
  // 头茬
  {
    title: "头茬",
    submenu: [
      {
        title: "生",
        submenu: ["文生", "武生"]
      },
      {
        title: "旦",
        submenu: ["正旦", "花旦", "老旦", "武旦"]
      },
      {
        title: "净",
        submenu: ["白脸", "绿脸", "黑脸", "红脸"]
      },
      { title: "末" },
      {
        title: "丑",
        submenu: ["花生儿", "花小儿"]
      },
      { title: "神" },
      { title: "鬼" },
      { title: "妖" },
      { title: "僧" },
      { title: "道" },
      { title: "冠帽" },
      { title: "例子头茬" },
      { title: "专用头茬" },
      { title: "现代头茬" },
      { title: "小孩头茬" }
    ]
  },
  // 戳子
  {
    title: "戳子",
    submenu: [
      {
        title: "蟒",
        submenu: ["龙袍", "蟒袍"]
      },
      {
        title: "靠",
        submenu: ["男靠", "女靠", "马靠", "神靠"]
      },
      { title: "掩衫" },
      { title: "站堂铠" },
      {
        title: "袍",
        submenu: ["道袍", "僧袍", "补子袍", "黑板袍"]
      },
      {
        title: "衣",
        submenu: [
          "仙衣",
          "八卦衣",
          "员外衣",
          "黑老板",
          "皂服",
          "素衣",
          "花衣",
          "文生衣",
          "龙凤衣",
          "号衣",
          "箭衣",
          "孝衣"
        ]
      },
      {
        title: "衫",
        submenu: ["男花衫", "女花衫", "老旦花衫"]
      },
      {
        title: "氅",
        submenu: ["老氅", "公子氅", "英雄氅", "花氅", "踢氅", "寿氅"]
      },
      { title: "绺堂" },
      { title: "马褂" },
      { title: "神怪戳子" },
      { title: "专用戳子" },
      { title: "现代戳子" },
      { title: "例子戳子" },
      { title: "小孩戳子" }
    ]
  },
  // 鞦子
  {
    title: "鞦子",
    submenu: [
      { title: "生" },
      { title: "旦" },
      { title: "净" },
      { title: "末" },
      { title: "丑" },
      { title: "例子" },
      { title: "大手厮" },
      { title: "神怪鞦子" },
      { title: "专用鞦子" },
      { title: "现代鞦子" },
      { title: "小跑子" }
    ]
  },
  // 动物
  {
    title: "动物",
    submenu: [{ title: "神兽" }, { title: "飞禽走兽" }]
  },
  // 衬景
  {
    title: "衬景",
    submenu: [
      { title: "花草树木" },
      { title: "山石门景" },
      { title: "亭台殿阁" },
      { title: "城桥塔寺" },
      { title: "神仙朵子" },
      { title: "地狱景象" },
      { title: "戏片子" }
    ]
  },
  // 道具
  {
    title: "道具",
    submenu: [
      { title: "室内陈设" },
      { title: "生活用具" },
      { title: "旗伞仪仗" },
      { title: "各式兵器" },
      { title: "车马船轿" },
      { title: "婴幼儿" },
      { title: "社火" }
    ]
  }
];
